var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.417 12.552c-1.334-.77-2-1.154-2-1.732 0-.577.666-.962 2-1.732l2.25-1.299c1.333-.77 2-1.155 2.5-.866.5.289.5 1.059.5 2.598v2.598c0 1.54 0 2.31-.5 2.598-.5.289-1.167-.096-2.5-.866l-2.25-1.299z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNDE2NjYgMTIuNTUyMkM4LjA4MzMyIDExLjc4MjQgNy40MTY2NiAxMS4zOTc1IDcuNDE2NjYgMTAuODIwMkM3LjQxNjY2IDEwLjI0MjggOC4wODMzMiA5Ljg1NzkyIDkuNDE2NjYgOS4wODgxMkwxMS42NjY3IDcuNzg5MDlDMTMgNy4wMTkyOSAxMy42NjY3IDYuNjM0MzkgMTQuMTY2NyA2LjkyMzA2QzE0LjY2NjcgNy4yMTE3NCAxNC42NjY3IDcuOTgxNTQgMTQuNjY2NyA5LjUyMTE0VjEyLjExOTJDMTQuNjY2NyAxMy42NTg4IDE0LjY2NjcgMTQuNDI4NiAxNC4xNjY3IDE0LjcxNzNDMTMuNjY2NyAxNS4wMDYgMTMgMTQuNjIxMSAxMS42NjY3IDEzLjg1MTNMOS40MTY2NiAxMi41NTIyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };